/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_NotesInputs */

const en_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const fr_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmerkungen`)
};

const it_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const ru_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания`)
};

const es_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

const zh_cn2_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔记`)
};

const ja_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注記`)
};

const hi_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स`)
};

const pt_pt2_metadata_merge_notes = /** @type {(inputs: Metadata_Merge_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Metadata_Merge_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_notes = /** @type {((inputs?: Metadata_Merge_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_notes(inputs)
	if (locale === "de") return de_metadata_merge_notes(inputs)
	if (locale === "it") return it_metadata_merge_notes(inputs)
	if (locale === "ru") return ru_metadata_merge_notes(inputs)
	if (locale === "es") return es_metadata_merge_notes(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_notes(inputs)
	if (locale === "ja") return ja_metadata_merge_notes(inputs)
	if (locale === "hi") return hi_metadata_merge_notes(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_notes(inputs)
	return en_metadata_merge_notes(inputs)
});